import React from "react";
import { Tag, Tooltip } from "antd";

// นาที → "X ชม. Y นาที"
export const formatMinutes = (minutes) => {
  if (minutes === null || minutes === undefined) return "-";
  const m = Math.max(0, Math.round(minutes));
  const h = Math.floor(m / 60);
  const r = m % 60;
  if (h === 0) return `${r} นาที`;
  if (r === 0) return `${h} ชม.`;
  return `${h} ชม. ${r} นาที`;
};

// "YYYY-MM-DD HH:mm:ss" → "HH:mm"
export const timeOf = (dt) => (dt ? dt.slice(11, 16) : "-");

// สไตล์หัวตารางกลาง — เทาเข้ม ตัวขาว (ให้เหมือนหน้ารายงานอื่นๆ เช่น Workload/EmployeeCase)
export const REPORT_HEADER_STYLE = {
  color: "white",
  fontWeight: "bold",
  backgroundColor: "#4a4a4a",
  textAlign: "center",
};
export const onReportHeaderCell = () => ({ style: REPORT_HEADER_STYLE });

// Tag กะ — โทนกลางให้เข้ากับตารางรายงาน (เลิกใช้ gold/geekblue/purple ที่หน้าอื่นไม่ใช้)
export const ShiftTag = ({ shiftName, shiftTime }) => (
  <span style={{ whiteSpace: "nowrap" }}>
    <Tag>{shiftName}</Tag>
    <span style={{ color: "#8c8c8c", fontSize: 12 }}>{shiftTime}</span>
  </span>
);

// Tag สถานะ (+ สายแนบในช่องเดียวกัน ให้ตารางไม่รก)
export const StatusTags = ({ record }) => {
  const tags = [];
  switch (record.status) {
    case "working":
      tags.push(<Tag key="s" color="blue">กำลังทำงาน</Tag>);
      break;
    case "no_out":
      tags.push(<Tag key="s" color="orange">ลืมตอกออก</Tag>);
      break;
    case "absent":
      tags.push(<Tag key="s" color="red">ไม่ได้ตอก</Tag>);
      break;
    // ลงวันหยุด/ลาไว้ = ไม่ใช่ขาดงาน แยกสีให้เห็นชัดว่าคนละเรื่องกัน
    case "holiday":
      tags.push(<Tag key="s" color="blue">วันหยุด</Tag>);
      break;
    case "leave":
      tags.push(
        <Tag key="s" color="purple">
          {record.holidayLabel || "ลา"}
        </Tag>
      );
      break;
    default:
      tags.push(<Tag key="s" color="green">ปกติ</Tag>);
  }
  if (record.lateMinutes > 0) {
    // สายรวม = มาสายจริง + ส่วนที่พักเกินสิทธิ์ 1 ชม. → แยกให้เห็นว่ามาจากไหน
    const parts = [];
    if (record.lateFromShift > 0) parts.push(`เข้าสาย ${formatMinutes(record.lateFromShift)}`);
    if (record.breakOverMinutes > 0) parts.push(`พักเกิน ${formatMinutes(record.breakOverMinutes)}`);
    tags.push(
      <Tooltip key="late" title={parts.join(" + ")}>
        <Tag color="volcano">สาย {formatMinutes(record.lateMinutes)}</Tag>
      </Tooltip>
    );
  }
  return <>{tags}</>;
};

// ช่อง "เข้า → ออก" อ่านปราดเดียวรู้
export const InOutCell = ({ record }) => {
  if (record.status === "absent") return <span style={{ color: "#bfbfbf" }}>—</span>;
  return (
    <span style={{ fontWeight: 600, whiteSpace: "nowrap" }}>
      {timeOf(record.clockIn)}
      <span style={{ color: "#8c8c8c", fontWeight: 400 }}> → </span>
      {record.status === "working" ? (
        <span style={{ color: "#1890ff", fontWeight: 400 }}>ยังทำงานอยู่</span>
      ) : record.clockOut ? (
        timeOf(record.clockOut)
      ) : (
        <span style={{ color: "#faad14", fontWeight: 400 }}>ไม่มีตอกออก</span>
      )}
    </span>
  );
};
